// What Auremin proposes to do with a counterparty (TX-US-0037): seven answers, every one
// required. The names are the API's - `Engagement` in trex/counterparties/engagement.py - and
// the labels and hints are what the form asks.

export const ENGAGEMENT_FIELDS = [
  {
    name: 'purpose',
    label: 'Nature and purpose of the proposed engagement',
    hint: 'Counterparty’s role, products/services involved and intended business arrangement.',
  },
  {
    name: 'volume_and_value',
    label: 'Estimated transaction volume and value',
    hint: 'Initial transaction and expected monthly/annual volumes and values, including currency.',
  },
  {
    name: 'product_source',
    label: 'Proposed source of product',
    hint: 'Supplier name, country of origin and loading/supply location.',
  },
  {
    name: 'counterparty_payment_terms',
    label: 'Proposed payment terms with the counterparty',
    hint: 'Advance payment, credit period, payment triggers and any proposed security or guarantees.',
  },
  {
    name: 'buyer_supplier_payment_terms',
    label: 'Proposed payment terms buyer/supplier',
    hint: 'Advance payment requirements, payment milestones and supplier credit period, if applicable.',
  },
  {
    name: 'financial_exposure',
    label: 'Expected financial exposure',
    hint: 'Estimated peak outstanding receivables, advance payments and funding requirements.',
  },
  {
    name: 'other_details',
    label: 'Other relevant commercial details',
    hint: 'Delivery location, Incoterms, delivery schedule, contract duration and key commercial risks or conditions.',
  },
];

// Mirrors MAX_ANSWER_LENGTH.
export const MAX_ANSWER_LENGTH = 4000;

// Every answer, empty where the record has none - a counterparty from before the engagement
// has no `engagement` at all.
export const engagementDraft = (record) => Object.fromEntries(
  ENGAGEMENT_FIELDS.map((field) => [field.name, record?.engagement?.[field.name] ?? '']),
);

export const engagementBody = (draft) => Object.fromEntries(
  ENGAGEMENT_FIELDS.map((field) => [field.name, (draft[field.name] ?? '').trim()]),
);

// The labels of the answers still to give, in the form's order.
export const unanswered = (draft) => ENGAGEMENT_FIELDS
  .filter((field) => !(draft[field.name] ?? '').trim())
  .map((field) => field.label);
